<template>
    <AbstractTheme color="#34991b" :name="this.$options.name" :misc="misc" :show="show"/>
</template>

<script>
import AbstractTheme from './AbstractTheme'

export default {
  name: 'Green',
  props: {
    misc: Object,
    show: Boolean,
  },
  components: { AbstractTheme },
}
</script>

<style lang="scss">
    //$color-primary: #34991b !default;
    //@import '../../scss/helpers/variables';
    //@import '../../scss/explorer';
</style>



// WEBPACK FOOTER //
// src/components/theme/Green.vue